<template>
    <div class="control has-icons-left has-icons-right">
        <div v-if="!isLoading">
    <b-autocomplete
        label="Select Eclipse Portfolio"
        field="nickname"
        :data="data"
        v-model="portfolio"
        @typing="searchPortfolios"
        @select="option => selected = option"
    >
    <template slot-scope="props">
        <strong>{{ props.option.nickname }}</strong>
    </template>

    <template slot="empty">No results found</template>
</b-autocomplete>
<b-button @click="saveTaxLotsAsPortfolio" :disabled="!selected || isLoading">
      Save Tax Lots as Portfolio
    </b-button>
</div>
<div v-else>
    Loading Orion Account Names...
</div>
</div>
</template>
<script>
export default {
    data() {
        return {
            data: [],
            selected: null,
            searching: false,
            portfolio: "",
            portfolios: [],
            isLoading: true
        }
    },
    props: {
        onLoadingExclusions: Function,
        onSelected: Function
    },
    watch: {
        selected() {
            this.doSelected()
           
        }
    },
    async created() {
        this.isLoading = true;
        let response = await fetch(`/api/v1/integrations/orion/eclipse/list_accounts/`,{
                method: 'GET'
            });
        const data = await response.json()
        if(data.error) {
            // location = '/brokerage/orion'
        } else {
            this.portfolios = data.results.map((d) => {
                d['nickname'] = d.accountName + " (" +  + d.accountId + ")"
                return d
            })
        }
        this.isLoading = false
    },
    methods: {
        async doSelected() {
            if(this.selected) { 
                this.onLoadingExclusions()
                let response = await fetch(`/api/v1/integrations/orion/eclipse/exclusions/?orion_account_id=${this.selected.id}`,{
                    method: 'GET'
                });
                try {
                    const data = await response.json()
                    this.selected.exclusions = data.results.filter((d) => {
                        return d.restrictionType == 1
                    }).map((d) => {
                            return d.ticker
                    });
                } catch {
                    
                }
            

                response = await fetch(`/api/v1/integrations/orion/eclipse/tax_lots/?orion_account_id=${this.selected.portfolioId}`,{
                    method: 'GET'
                });
                const data2 = await response.json()
                const ourSymbols = data2.results.map((r)=> {
                    return(r.symbol)
                })
                this.onSelected(this.selected, ourSymbols)

            }
        },
        async searchPortfolios(searchTerm) {
            searchTerm = searchTerm.toUpperCase()
            this.data = this.portfolios.filter((portfolio) => {
                    return(portfolio.accountName.toUpperCase().indexOf(searchTerm) != -1)
                }
            )
        },
        async saveTaxLotsAsPortfolio() {
            if (!this.selected) return;
            
            const defaultName = `${this.selected.accountName} Tax Lots`;
            this.$buefy.dialog.prompt({
                message: 'Enter a name for the portfolio',
                inputAttrs: {
                    maxlength: 250,
                    value: defaultName
                },
                confirmText: 'Save',
                cancelText: 'Cancel',
                onConfirm: async (portfolioName) => {
                    try {
                        const response = await fetch('/api/v1/integrations/orion/eclipse/tax_lots/save_tax_lots_as_portfolio/', {
                            method: 'POST',
                            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': this.$root.$data.csrfToken,
            },
                            body: JSON.stringify({
                                orion_account_id: this.selected.portfolioId,
                                portfolio_name: portfolioName || defaultName
                            })
                        });

                        if (response.ok) {
                            const result = await response.json();
                            this.$buefy.toast.open({
                                message: `Portfolio "${result.portfolio_name}" created successfully!`,
                                type: 'is-success'
                            });
                        } else {
                            throw new Error('Failed to save portfolio');
                        }
                    } catch (error) {
                        this.$buefy.toast.open({
                            message: 'Error saving portfolio: ' + error.message,
                            type: 'is-danger'
                        });
                    }
                }
            });
        }
    }
}
</script>
